import { render, staticRenderFns } from "./DividerComponent.vue?vue&type=template&id=5e81f841&scoped=true&"
import script from "./DividerComponent.vue?vue&type=script&lang=js&"
export * from "./DividerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DividerComponent.vue?vue&type=style&index=0&id=5e81f841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81f841",
  null
  
)

export default component.exports